module.exports = __webpack_public_path__ + "media/images/preview_recipe_2-b686d5b71c016f8106837da7ad1be596.webp";